import { motion } from 'framer-motion';

export default function Testimonials() {
  const testimonials = [
    {
      quote: "Benjamin hat unsere Webseite komplett transformiert. Die Anfragen haben sich innerhalb von 3 Monaten verdreifacht. Absolut professionelle Arbeit!",
      author: "Thomas Müller",
      role: "Geschäftsführer, Müller & Partner GmbH",
      avatar: "https://public.readdy.ai/ai/img_res/d6028ef36e2bdf70b5d36f1a4bdb19d1.jpg",
      rating: 5
    },
    {
      quote: "Der AI-Chatbot von BR Webdesign beantwortet Kundenanfragen rund um die Uhr. Unsere Conversion-Rate ist um 45% gestiegen. Klare Empfehlung!",
      author: "Sandra Weber",
      role: "Marketing-Leiterin, Weber Consulting",
      avatar: "https://readdy.ai/api/search-image?query=professional%20german%20business%20woman%20marketing%20director%20portrait%20with%20friendly%20expression%20in%20corporate%20environment%2C%20executive%20headshot%20with%20clean%20background&width=80&height=80&seq=test2-de&orientation=squarish",
      rating: 5
    },
    {
      quote: "Von der Beratung bis zur Umsetzung – alles war erstklassig. Benjamin versteht, was Unternehmen wirklich brauchen, um online erfolgreich zu sein.",
      author: "Michael Schneider",
      role: "Inhaber, Schneider Handwerk",
      avatar: "https://readdy.ai/api/search-image?query=professional%20german%20business%20man%20owner%20portrait%20with%20warm%20smile%20in%20startup%20office%2C%20entrepreneur%20headshot%20with%20modern%20background&width=80&height=80&seq=test3-de&orientation=squarish",
      rating: 5
    },
    {
      quote: "Unsere neue Webseite ist eine echte Verkaufsmaschine. Die Ladezeiten sind blitzschnell und wir ranken jetzt auf Seite 1 bei Google. Fantastisch!",
      author: "Lisa Hoffmann",
      role: "Gründerin, Hoffmann Digital",
      avatar: "https://readdy.ai/api/search-image?query=professional%20german%20business%20woman%20founder%20portrait%20with%20confident%20look%20in%20tech%20company%20office%2C%20technology%20executive%20headshot%20with%20contemporary%20background&width=80&height=80&seq=test4-de&orientation=squarish",
      rating: 5
    },
    {
      quote: "Die AI-Automatisierung hat unseren Kundenservice revolutioniert. Wir sparen jetzt 20 Stunden pro Woche und die Kunden sind begeistert.",
      author: "Markus Fischer",
      role: "E-Commerce Manager, Fischer Mode",
      avatar: "https://readdy.ai/api/search-image?query=professional%20german%20business%20man%20ecommerce%20manager%20portrait%20with%20professional%20demeanor%20in%20corporate%20setting%2C%20executive%20headshot%20with%20clean%20background&width=80&height=80&seq=test5-de&orientation=squarish",
      rating: 5
    },
    {
      quote: "Benjamin hat nicht nur eine Webseite gebaut, sondern eine komplette digitale Strategie entwickelt. Die Investition hat sich innerhalb von 2 Monaten amortisiert.",
      author: "Anna Becker",
      role: "Geschäftsführerin, Becker Immobilien",
      avatar: "https://readdy.ai/api/search-image?query=professional%20german%20business%20woman%20managing%20director%20portrait%20with%20confident%20expression%20in%20modern%20office%2C%20leadership%20headshot%20with%20neutral%20background&width=80&height=80&seq=test6-de&orientation=squarish",
      rating: 5
    }
  ];

  return (
    <section className="py-20 sm:py-24 bg-white relative overflow-hidden">
      <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-br from-brand-beige/30 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-brand-green/10 to-transparent rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            Das sagen meine Kunden
          </h2>
          <p className="text-lg sm:text-xl text-brand-grey max-w-3xl mx-auto px-4">
            Überzeugen Sie sich selbst – echte Ergebnisse von echten Unternehmen
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-brand-beige-light rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition-all border border-brand-beige hover:border-brand-green group"
            >
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-brand-green"></i>
                ))}
              </div>

              <p className="text-brand-grey leading-relaxed mb-6 italic text-sm">
                &quot;{testimonial.quote}&quot;
              </p>

              <div className="flex items-center gap-4">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="font-semibold text-brand-black group-hover:text-brand-green transition-colors text-sm">
                    {testimonial.author}
                  </div>
                  <div className="text-xs text-brand-grey">{testimonial.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}